import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import {
  getDataApi1,
  loadApi,
  saveApi1,
  loadApi1,
  delApi1,
} from "../services/appApi";
import axios from "axios";
import numeral, { options } from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from "primereact/toolbar";
import { Tooltip } from "primereact/tooltip";
import { InputTextarea } from 'primereact/inputtextarea';       

const TaxDocuments = () => {
  const userId = localStorage.getItem("taxUserId");

  const getDispDate4 = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DD") : null;
  };
 
  const getOraDateFormat24 = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DDTHH:mm:ss[Z]") : null;
  };



  let emptyRow = {
          client_tax_document_id: null,                                                             
          client_id: null,                                                                          
          tax_year: null,                                                                           
          document_file_name: "",                                                                   
          spouse_tax_document_flag: "",                                                             
          provider_name: "",                                                                        
          tax_document_type_lkcd_1: "",                                                             
          tax_document_type_lkcd_2: "",                                                             
          tax_document_type_lkcd_3: "",                                                             
          tax_document_type_lkcd_4: "",                                                             
          tax_document_type_lkcd_5: "",                                                             
          tax_document_type_lkcd_6: "",                                                             
          document_processed_flag: "",                                                              
          document_notes: "",                                                                       
          document_description: "",                                                                 
          document_received_date: "",                                                               
          document_processed_date: "",                                                              
   
  };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [orginalRow, setOriginalRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filters, setFilters] = useState({
    client_first_name: { value: null, matchMode: FilterMatchMode.IN },
    tax_year: { value: null, matchMode: FilterMatchMode.IN },
  });
  const [apiErrorDialog, setApiErrorDialog] = useState(
    sessionStorage.getItem("taxSessionExpired") === "true",
  );
  const [showDialog, setShowDialog] = useState(false);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [currentMode, setCurrentMode] = useState(''); 
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);

  useEffect(() => {
    const fetchClient = async () => {
      setFetchClientFlag(true);
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        while (hasMore) {
          const response = await getDataApi1(
            `/ords/tax/ztx_firm_clients_v/?offset=${offset}&limit=${limit}`,
          );
          allData = [...allData, ...response.data.items];
          status = response.status;
          hasMore = response.data.hasMore;
          offset = offset + limit;
        }
        if (allData.length > 0) {
          const options = allData.map((item) => ({
            label: item.client_first_name,
            value: item.client_id,
          }));
          setClientNameOptions(options);
          console.log(options);
          setFetchClientFlag(false);
        }
      } catch (err) {
        console.error(err);
        setFetchClientFlag(false);
      }
    };
    fetchClient();
  }, []);

  const fetchRows = async () => {
    try {
      let offset = 0;
      let limit = 25;
      let hasMore = true;
      let allData = [];
      let status = null;
      setIsLoading(true);
      while (hasMore) {
        const response = await getDataApi1(
          `/ords/tax/ztx_client_tax_documents_v/?offset=${offset}&limit=${limit}`,
        );
        console.log(response);
        allData = [...allData, ...response.data.items];
        console.log(allData);
        status = response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
      }
      if (status == 200 && !hasMore) {
        if (allData.length > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data fetched successfully",
          });
          setRows(allData);
          setIsLoading(false);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
        }
        //setSearch(response.data);
      } else {
        //setRows(null);
        setRows([]);
        setIsLoading(false);
        const errorInfo = "Error";

        // Set the error message and display the dialog
        setErrorMessage(errorInfo);
        setErrorDialogVisible(true);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
        setIsLoading(false);
      } else {
        // Set the error message and display the dialog
        setIsLoading(false);
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  };
  useLayoutEffect(() => {
    if (!fetchStarted.current) {
      fetchStarted.current = true;
      fetchRows();
    }
  }, []);

   const receivedDateTemplate = (rowData) => {
    return getDispDate4(rowData.document_received_date)
  };
  const processedDateTemplate = (rowData) => {
    return getDispDate4(rowData.document_processed_date)
  };


  /***Velmani commented on 7/5/2026 - can we just use the Templates suffixed abve?
   * const receivedDate = row.document_received_date
    ? moment.utc(row.document_received_date).format("YYYY-MM-DD")
    : null;
  const processedDate = row.document_processed_date
    ? moment.utc(row.document_processed_date).format("YYYY-MM-DD")
    : null; ***/

  const checkboxBodyTemplate = (rowData) => {
    return rowData.document_processed_flag ? (
      <Checkbox checked={rowData.document_processed_flag === "Y"} disabled />
    ) : null;
  };

  const checkboxBody = row.document_processed_flag ? (
    <Checkbox checked={row.document_processed_flag === "Y"} disabled />
  ) : (
    <div className="box">{row.document_processed_flag}</div>
  );

  const hideDialog = () => {
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowDialog(true);
  };

  const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U')
    setShowDialog(true);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowDialog(true);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="flex justify-content-center align-items-center min-h-screen p-5">
          <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div
              style={{ backgroundColor: "var(--primary-color" }}
              className="text-white p-3 text-center border-round-top"
            >
              <h2 className="m-0">TaxDocuments Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
              <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
          </Card>
        </div>
      </React.Fragment>
    );
  };
  const getLoadedHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="header-container">
          <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
            TaxDocuments
          </h2>
          <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
            <div className="header-container p-1">
              <style>
                {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
              </style>
              <span className="p-input-icon-right w-full md:w-auto">
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Search..."
                  className="w-full lg:w-auto text-sm p-3"
                  style={{ fontSize: "17px" }}
                />
              </span>
            </div>
          </h2>
        </div>
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-start">
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-success p-button-rounded p-mr-2"
          onClick={showNewProduct}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "1.25rem" }}
        />
      </div>
    </div>
  );

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };
  const editBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-secondary"
          onClick={() => showEditProduct(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const clientOptions = [
    ...new Set(rows.map((item) => item.client_first_name).filter(Boolean)),
  ].map((client_first_name) => ({
    label: client_first_name,
    value: client_first_name,
  }));

  const taxYearOptions = [
    ...new Set(rows.map((item) => item.tax_year).filter(Boolean)),
  ].map((tax_year) => ({
    label: tax_year,
    value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect
      value={options.value || []}
      options={clientOptions}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Select Client"
      display="chip"
      showClear
    />
  );

  const taxYearFilterTemplate = (options) => (
    <MultiSelect
      value={options.value || []}
      options={taxYearOptions}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Select"
      display="chip"
      showClear
    />
  );


  const saveData = async (currentMode) => {
    if(currentMode === 'I') {
    try {
      const p_param = {
        p_user_id: userId,
        p_client_id: row.client_id,
        p_document_description: row.document_description,
        p_document_file_name: row.document_file_name,
        p_document_notes: row.document_notes,
        p_document_processed_date: row.document_processed_date
          ? moment(row.document_processed_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
        p_document_processed_flag: row.document_processed_flag,
        p_document_received_date: row.document_received_date
          ? moment(row.document_received_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
        p_tax_year: row.tax_year,
      };
      console.log("Insert p_param: ", p_param);
      const response = await loadApi1(
        p_param,
        "/ords/tax/ztx_client_tax_documents/v1/",
      );
      console.log(response);
      console.log(response.data);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Inserted",
        });
        const newRow = {
          client_tax_document_id: response.data.o_client_tax_document_id,
          ...row,
        };
        setRows((prev) => [...prev, newRow]);
        setShowDialog(false);
        setCurrentMode('');
        setRow(emptyRow);
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Inserted",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
        setErrorDialogVisible(true);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  } else if (currentMode === 'U'){

     const p_param = {                                                                              
	  p_user_id: userId,                                                                                  
          p_client_tax_document_id: row.client_tax_document_id,                                       
          p_client_id: row.client_id,                                                                 
          p_tax_year: row.tax_year,                                                                   
          p_document_file_name: row.document_file_name,                                               
          p_spouse_tax_document_flag: row.spouse_tax_document_flag,                                   
          p_provider_name: row.provider_name,                                                         
          p_tax_document_type_lkcd_1: row.tax_document_type_lkcd_1,                                   
          p_tax_document_type_lkcd_2: row.tax_document_type_lkcd_2,                                   
          p_tax_document_type_lkcd_3: row.tax_document_type_lkcd_3,                                   
          p_tax_document_type_lkcd_4: row.tax_document_type_lkcd_4,                                   
          p_tax_document_type_lkcd_5: row.tax_document_type_lkcd_5,                                   
          p_tax_document_type_lkcd_6: row.tax_document_type_lkcd_6,                                   
          p_document_processed_flag: row.document_processed_flag,                                     
          p_document_notes: row.document_notes,                                                       
          p_document_description: row.document_description,                                           
          p_document_received_date: getOraDateFormat24(row.document_received_date),                 
          p_document_processed_date: getOraDateFormat24(row.document_processed_date),               
     };                                                                                             
   
    console.log("Edit p_param: ", p_param);
    try {
      const response = await saveApi1(
        p_param,
        `/ords/tax/ztx_client_tax_documents/v1/`,
      );
      console.log(response);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Updated",
        });
        setRows((prev) =>
          prev.map((data) =>
            data.client_tax_document_id === row.client_tax_document_id
              ? { ...row }
              : data,
          ),
        );
        setShowDialog(false);
        setCurrentMode('');
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Updated",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  }
  };

  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

  const confirmDeleteRow = (row) => {
    setRow(row);
    setDeleteRowDialog(true);
  };

  const deleteRow = async () => {
    const p_param = {
      p_user_id: userId,
      p_client_tax_document_id: row.client_tax_document_id,
    };
    try {
      const response = await delApi1(
        { params: p_param },
        "/ords/tax/ztx_client_tax_documents/v1/",
      );
      console.log("Delete res: ", response);
      let successFlag = response.data.o_success_flag;
      if (successFlag === "Y") {
        let _rows = rows.filter(
          (val) => val.client_tax_document_id !== row.client_tax_document_id,
        );
        setRows(_rows);
        setDeleteRowDialog(false);
        setRow(emptyRow);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "TaxDocument Deleted",
          life: 3000,
          width: "600px",
        });
      } else {
        let err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "TaxDocument Not Deleted",
          life: 3000,
          width: "600px",
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "TaxDocument Deletion Failed",
        life: 3000,
        width: "600px",
      });
    }
  };

  const deleteRowDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        severity="secondary"
        onClick={hideDeleteRowDialog}
      />
      <Button label="Yes" icon="pi pi-check" onClick={deleteRow} />
    </React.Fragment>
  );

  const actionBodyDeleteTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-warning"
          onClick={() => confirmDeleteRow(rowData)}
          tooltip="Delete"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

 

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
        {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!isLoading && (
          <div className="card mb-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">TaxDocuments</div> */}
            <Tooltip target=".p-row-editor-init" content="Edit" event="both" position="bottom"/>
            <DataTable
              ref={dt}
              value={rows}
              scrollable
              scrollHeight="flex"
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="client_tax_document_id"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={taxPageRows}
              rowsPerPageOptions={taxRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No data found"
              stripedRows
              showGridlines
              removableSort
              filters={filters}
              filterDisplay="row"
              onFilter={(e) => setFilters(e.filters)}
              // editMode="row"
              // onRowEditComplete={onRowEditComplete}
            >
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              {/* <Column
                rowEditor
                headerStyle={{ width: "10rem" }}
                bodyClassName={{ textAlign: "center" }}
              ></Column> */}
               <Column
                body={editBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                body={actionBodyDeleteTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                field="client_first_name"
                header="Client"
                sortable
                filter
                showFilterMenu={false}
                // editor={(options) => dropdownEditor(options)}
                filterMenuStyle={{ width: "14rem" }}
                filterElement={clientFilterTemplate}
              ></Column>
              <Column
                field="tax_year"
                header="Tax Year"
                filter
                showFilterMenu={false}
                // editor={(options) => yearEditor(options)}
                filterElement={taxYearFilterTemplate}
                bodyStyle={{ textAlign: "right" }}
                sortable
              ></Column>
              <Column
                field="provider_name"
                header="Provider"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="tax_document_type_lkcd_1"
                header="Type"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="document_file_name"
                header="File Name"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="document_processed_flag"
                header="Processed"
                // editor={(options) => checkboxEditor(options)}
                body={checkboxBodyTemplate}
                bodyStyle={{ textAlign: "center" }}
                sortable
              ></Column>
              <Column
                field="document_notes"
                header="Notes"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="tax_document_type_lkcd_2"
                header="Type2"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="tax_document_type_lkcd_3"
                header="Type3"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="tax_document_type_lkcd_4"
                header="Type4"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="document_description"
                header="Description"
                // editor={(options) => textEditor(options)}
                sortable
              ></Column>
              <Column
                field="document_received_date"
                header="Received Date"
                // editor={(options) => dateEditor(options)}
                body={receivedDateTemplate}
                sortable
              ></Column>
              <Column
                field="document_processed_date"
                header="Processed Date"
                // editor={(options) => dateEditor(options)}
                body={processedDateTemplate}
                sortable
              ></Column>
            </DataTable>
          </div>
        )}

        <Dialog
          // header="Add TaxDocument"
          header={currentMode === 'I' ? "Add TaxDocument" : currentMode === 'U' ? "Update TaxDocument" : currentMode === 'R' ? "View TaxDocument" : "TaxDocument"}
          visible={showDialog}
          style={{ width: "40rem" }}
          onHide={() => setShowDialog(false)}
        >
          <div className="p-fluid">
            <div className="field">
              <label>Client</label>
              <Dropdown
                value={row.client_id}
                disabled = {currentMode === 'R' ? true : false}
                options={clientNameOptions}
                optionLabel="label"
                optionValue="value"
                placeholder="Select Client"
                onChange={(e) => {
                  const selectedOption = clientNameOptions.find(
                    (option) => option.value === e.value,
                  );
                  setRow({
                    ...row,
                    client_id: e.value,
                    client_first_name: selectedOption?.label || "",
                  });
                }}
              />
            </div>
            <div className="field">
              <label>Tax Year</label>
              <InputNumber
                value={row.tax_year}
                disabled = {currentMode === 'R' ? true : false}
                useGrouping={false}
                onChange={(e) => setRow({ ...row, tax_year: e.value })}
              />
            </div>
            <div className="field">
              <label>File Name</label>
              <InputText
                value={row.document_file_name}
                disabled = {currentMode === 'R' ? true : false}
                onChange={(e) =>
                  setRow({ ...row, document_file_name: e.target.value })
                }
              />
            </div>
            <div className="field">
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <label>Processed</label>
                <Checkbox
                  checked={row.document_processed_flag === "Y"}
                  disabled = {currentMode === 'R' ? true : false}
                  onChange={(e) =>
                    setRow({
                      ...row,
                      document_processed_flag: e.checked ? "Y" : "N",
                    })
                  }
                />
              </div>
            </div>
            <div className="field">
              <label>Notes</label>
              {/* <InputText
                value={row.document_notes}
                onChange={(e) =>
                  setRow({ ...row, document_notes: e.target.value })
                }
              /> */}
              <InputTextarea value={row.document_notes} disabled = {currentMode === 'R' ? true : false} onChange={(e) => setRow({ ...row, document_notes: e.target.value })} rows={5} cols={30} />
            </div>
            <div className="field">
              <label>Description</label>
              <InputText
                value={row.document_description}
                disabled = {currentMode === 'R' ? true : false}
                onChange={(e) =>
                  setRow({ ...row, document_description: e.target.value })
                }
              />
            </div>
            <div className="field">
              <label>Received Date</label>
              <Calendar
                value={row.document_received_date ? new Date(row.document_received_date) : null}
                disabled = {currentMode === 'R' ? true : false}
                dateFormat="yy-mm-dd"
                showIcon
                onChange={(e) =>
                  setRow({ ...row, document_received_date: e.value })
                }
              />
            </div>
            <div className="field">
              <label>Processed Date</label>
              <Calendar
                value={row.document_processed_date}
                disabled = {currentMode === 'R' ? true : false}
                dateFormat="yy-mm-dd"
                showIcon
                onChange={(e) =>
                  setRow({ ...row, document_processed_date: e.value })
                }
              />
            </div>
            <div
              style={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: "0.5rem",
              }}
            >
              <Button
                label="Cancel"
                icon="pi pi-times"
                severity="secondary"
                onClick={() => {
                  setShowDialog(false);
                  setRow(emptyRow);
                  setCurrentMode('');
                }}
              />
              <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
            </div>
          </div>
        </Dialog>
        <Dialog
          visible={deleteRowDialog}
          style={{ width: "450px" }}
          header="Confirm"
          modal
          footer={deleteRowDialogFooter}
          onHide={hideDeleteRowDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3"
              style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
            />
            {row && (
              <span>
                Are you sure you want to delete <b>{row.machine_name}</b>?
              </span>
            )}
          </div>
        </Dialog>
        {!apiErrorDialog && (
          <Dialog
            header="API Error"
            visible={errorDialogVisible}
            style={{ width: "25rem" }}
            onHide={hideDialog}
            footer={
              <Button
                label="OK"
                onClick={hideDialog}
                className="p-button-primary p-button-rounded"
              />
            }
          >
            <p>{errorMessage}</p>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default TaxDocuments;
